import { ResultListState } from '@coveo/headless';
import { SiteSearchResultRaw } from 'lib/types/coveo/SiteSearchResult';

export const uniqueSiteRelatedCommunities = (state?: ResultListState): string[] => {
  const communities = new Set<string>();

  for (const result of state?.results ?? []) {
    const raw = result.raw as unknown as SiteSearchResultRaw;
    for (const community of raw.site_relatedcommunities ?? []) {
      const trimmed = community?.trim();
      if (trimmed) {
        communities.add(trimmed);
      }
    }
  }

  return Array.from(communities).sort((a, b) => a.localeCompare(b));
};
